<template>
  <div style="height:100%;width:100%">
    <div class="bg-box">
      <div class="content" v-if="resData">
        <div class="title">{{resData.orgName}}</div>
        <div class="title" style="  line-height: 3.5rem;">{{resData.voteTitle}}</div>
        <div class="vote-content">
          <p class="item-box">
            <span class="time-box">参与人员:</span>
            <span class="time-box">{{resData.roleName}}</span>
          </p>
          <p class="item-box">
            <span class="time-box">投票时间:</span>
            <span class="time-box">{{resData.voteStartTime}} 至 {{resData.voteExpiryTime}}</span>
          </p>
          <p class="item-box">
            <span class="time-box">计票统计:</span>
            <span
              class="time-box"
            >应到投票人:{{resData.voters}} 名，每人{{resData.ticket}} 票，总票数为{{resData.votes}}票。实际投票人:{{resData.actualVoters}} 人，实际已投票数:{{resData.actualVotes}}票</span>
          </p>
          <p class="item-box">
            <span class="time-box">投票生效:</span>
            <span class="time-box">实际投票人数达应到投票人数的{{resData.voteRatio}}</span>
          </p>
          <p class="item-box">
            <span class="time-box">投票通过:</span>
            <span class="time-box">投票选项票数超过实际投票票数的{{resData.optionRatio}}</span>
          </p>
          <p class="item-box">
            <span class="time-box vote-res">投票结论:</span>
            <span class="time-box vote-res">{{filterRes(resData.isFailure)}}</span>
            <span class="time-box vote-res" v-if="resData.percentage">【{{resData.percentage}}】</span>
            <span class="time-box vote-res" v-if="resData.passOption">【{{resData.passOption}}】</span>
          </p>
          <div class="title">投票选项计票</div>
          <div v-for="(item,index) in options" :key="index" class="tr-box">
            <div class="title-box">{{item.optionName}}</div>
            <div class="title-num">{{item.ballotCount}}</div>
            <div class="clear-box"></div>
          </div>

         <!-- <div class="title">投票内容</div>
          <div class="vote-content-text">
              {{resData.votingContents}}
          </div> -->
		  <div id="footer">
		    <el-row>
		      <el-col :span="23" :offset="1" class="title-text-content" >投票内容</el-col>
		    </el-row>
		    <el-row class="vote-content" v-if="resData.votingContents">
		      <!-- 45 -->
		      <el-col :span="22" :offset="1" class="vote-content-text content-text-box">
		        <p class="ql-editor" id="content" v-html="resData.votingContents"></p>
		      </el-col>
		    </el-row>
		    <el-row>
		      <el-col :span="22" style="text-align: right;">
		        <vue-qr :text="qrUrl" :size="120"></vue-qr>
		      </el-col>
		    </el-row>
		    <el-row >
		      <el-col :span="22" class="time-box" style=" text-align: right;  letter-spacing: 2px;">
		        {{resData.voteExpiryTime}}
		      </el-col>
		    </el-row>
		  </div>
		  
        </div>
        <!-- <div class="vote-content-btn"  v-if="resData.outcome">
                <a href="#" class="btn" @click="downLoad()">下载投票报告单 </a>
        </div>
         <div class="vote-content-btn-text" v-else>
                投票报告单还未生成，赶紧通知管理员生成吧!
        </div> -->
        <div class="footer">
          &copy; 遵义云讯网络科技有限责任公司 &copy;2019
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52030302000614" target="_blank" class="beian">
            <img src="../assets/image/beian.png" class="image-box" />
            <span>黔ICP备19011880号</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from "../commen/url"
export default {
  name: "pollPdf",
  data() {
    return {
      voteId: "",
      orgId: "",
      resData: null,
      options: null
    };
  },
  methods: {
    getVoteRes() {
      let cnt = {
        orgId: this.orgId,
        voteId: this.voteId
      };
	  
	  	console.log(cnt)
		debugger
      this.$api.getVoteReportData(cnt, res => {
		  debugger
		console.log("报告单返回结果")
		console.log(res.data.c);
        if (res.data.rc == this.$util.RC.SUCCESS) {
          this.resData = res.data.c;
        } else {
          this.resData = null;
        }
        this.options = JSON.parse(this.resData.optionArray);
        
      });
    },
    downLoad(){
      let strUrl = url.ossUrl+this.resData.outcome
      window.location.href = strUrl
    },
    filterRes(key) {
      let str = "";
      if (key == 0) {
        str = "投票成功";
      } else if (key == 1) {
        str = "投票失败";
      } else {
        str = "投票失效";
      }
      return str;
    },
  },
  mounted() {
	console.log("进入投票验证")
    this.voteId = this.$route.query.voteId;
    this.orgId = this.$route.query.orgId;
	debugger
    this.getVoteRes();
  }
};
</script>

<style scoped lang="scss">
.bg-box {
  width: 100%;
  min-height: 100%;
  background-image: url("../assets/image/bg.jpg");
  // background-size: 100%;
  background-position: center;
  background-size: cover;
}
.content {
  min-height: 100%;
  padding: 0 1.5rem 2rem 1.5rem;

  background: rgba($color: #fff, $alpha: 0.4);
}
.title {
  width: 100%;
  min-height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-weight: 600;
  font-size: 2.2rem;
  color: #7dacc0;
}
.code {
  width: 100%;
  height: 4rem;
  margin-top: 1rem;
  color: #333;
  font-weight: 600;
  font-size: 1.8rem;
}
.text {
  margin-top: 1rem;
  color: #333;
  font-size: 1.4rem;
  line-height: 2rem;
}

.org-info {
  width: 100%;
  margin-top: 2rem;
}
.org-name {
  width: 100%;
}
.org-title {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  color: #fff;
  font-size: 1.6rem;
  text-align: center;
  background: #98cee5;
  border-radius: 5px;
}
.org-name-text {
  margin-top: 1rem;
  width: 100%;
  font-size: 1.6rem;
  line-height: 2rem;
}

.user-list {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 5px;
  background: rgba($color: #fff, $alpha: 0.8);
  font-size: 1.6rem;
  color: #333;
}
.item p {
  line-height: 3rem;
}
.footer {
  margin-top: 4rem;
  width: 100%;
  height: 4rem;
  color: #666;
  font-size: 1.4rem;
  text-align: center;
}
.vote-content {
  font-size: 1.6rem;
  color: #333;
}
.item-box {
  color: #333;
  font-size: 1.6rem;
  line-height: 2rem;
  margin-top: 2rem;
}
.title-box {
  float: left;
  width: 50%;
  height: 4rem;
  line-height: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-weight: 600;
}
.title-num {
  float: left;
  width: 50%;
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.tr-box {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  overflow: hidden;
  color: #333;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
}
.clear-box {
  clear: both;
}
.vote-content-text {
  width: 100%;
  line-height: 3rem;
  font-size: 1.4rem;
  color: #333;
}
.vote-content-btn{
    width: 100%;
    text-align: center;
    margin-top: 4rem;

}
.btn{

    height: 3rem;
    line-height: 3rem;
    color: #fff;
    background: #409EFF;
    font-size: 1.6rem;
    text-align: center;
    padding: 1rem 2rem;
    border-radius: 15px;;

}
a{
    text-decoration:none;
    color:inherit;
}
.vote-content-btn-text{
  margin-top: 2rem;
    line-height: 4rem;
    font-size: 1.6rem;
    text-align: center;
    color: #666;
}
</style>